import { useEffect, useMemo, useRef, useState } from "react";
import { _Credit, _CreditAccount, _Message, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { InputDate } from "../../../../theme/Input/InputDate";
import { ValidationOtp } from "../../../../theme/Component/ValidationOTP/ValidationOtp";
import { toast } from "react-toastify";
import { ModalGeneric } from "../../../../../interfaces";
import { Modal } from "../../../../theme/Component/Modal";
import useModal, { MODAL_LG } from "../../../../theme/Component/hooks/useModal";
import AutoChart from "../../../../../core/graph/AutoChart";
import { DropDown } from "../../../../theme/Component/DropDown";

interface Props {
    stateComite: number;
    onCreateComite:any;
}
export const CrearComiteCredito = ({ stateComite,onCreateComite }: Props) => {

    
    const _credit = useDataBean(_CreditAccount);
    const otpAcc = useDataBean(_Message);
    const { bean, setBean, lista, setLista, handleChange } = _credit;
    const [firmas, setFirmas] = useState<any>([]);
    const [data, setData] = useState<any>([]);
    const [acc, setAcc] = useState<any>({});
    const [fechaCorte, setFechaCorte] = useState<any>(_single.getCurrenDate());
    const [noActa, setNoActa] = useState<string>('Acta No. ');
    const modalGraph = useModal("Grafica",MODAL_LG);
    const [modal, setModal] = useState<ModalGeneric>({
        name: 'Queremos validar tu identidad',
        tabIndex: -1,
        view: false,
        btnClose: true,
        btnSubmit: true,
        format: 'modal-md',
    });

    useEffect(() => {
        getComiteCreditoValoresRender();
    }, [stateComite])

    const addFirma = () => {
        if (firmas.some(f => f.IDAccount === acc.IDAccount)) {
            toast.warn('Esta firma ya fue agregada');
            return;
        }

        setFirmas(prev => [...prev, {
            IDAccount: acc.IDAccount,
            Name: acc.EntityName,
            Nit: acc.Nit,
            Cargo: data.Cargo,
            Validated: false
        }]);
        setData({});
        setAcc({});
    };


    const getComiteCreditoValoresRender = () => {
        _credit.instance.getComiteCreditoValoresRender(1, 5000, { State: stateComite }, fechaCorte).then(
            (resp: any) => {
                if (resp.List) {

                    setLista(resp.List);
                    
                }
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDCreditCommite', visible: true, mask: MASK_NUMBER },
        { title: 'Linea Credito', property: 'LoanLineName', visible: true },
        { title: 'Caja Nominadora', property: 'NominaName', visible: true },    
        { title: 'Grado', property: 'IDGradoPersonaName', visible: true },
        { title: 'Identificacion', property: 'NitDeudor', visible: true, mask: MASK_NUMBER },
        { title: 'Solicitante', property: 'DeudorName', visible: true },        
        { title: 'Valor Solicitado', property: 'AmountApprove', visible: true, mask: MASK_MONEY },
        { title: 'Deduccion Capital', property: 'DeduccionCapital', visible: true, mask: MASK_MONEY },
        { title: 'Deduccion Interes', property: 'DeduccionInteres', visible: true, mask: MASK_MONEY },
        { title: 'Total Desembolso', property: 'TotalDesembolso', visible: true, mask: MASK_MONEY },
        { title: 'Plazo', property: 'Cuotes', visible: true, mask: MASK_NUMBER },        
        { title: 'Novacion', property: 'ResumeNovacion', visible: true },
        { title: 'Observaciones', property: 'Observation', visible: true },        
    ]
    const headGraph = [
        { title: 'ID', property: 'IDCreditCommite', visible: true, mask: MASK_NUMBER },
        { title: 'Linea Credito', property: 'LoanLineName', visible: true },
        { title: 'Caja Nominadora', property: 'NominaName', visible: true },    
        { title: 'Grado', property: 'IDGradoPersonaName', visible: true },
        { title: 'Genero', property: 'IDGeneroName', visible: true },
        { title: 'Ciudad Residencia', property: 'CiudadResidencia', visible: true },
        { title: 'Identificacion', property: 'NitDeudor', visible: true, mask: MASK_NUMBER },
        { title: 'Solicitante', property: 'DeudorName', visible: true },        
        { title: 'Valor Solicitado', property: 'AmountApprove', visible: true, mask: MASK_MONEY },
        { title: 'Deduccion Capital', property: 'DeduccionCapital', visible: true, mask: MASK_MONEY },
        { title: 'Deduccion Interes', property: 'DeduccionInteres', visible: true, mask: MASK_MONEY },
        { title: 'Total Desembolso', property: 'TotalDesembolso', visible: true, mask: MASK_MONEY },
        { title: 'Plazo', property: 'Cuotes', visible: true, mask: MASK_NUMBER },        
        { title: 'Novacion', property: 'ResumeNovacion', visible: true },
        { title: 'Observaciones', property: 'Observation', visible: true },        
    ]

    const [timer, setTimer] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(true);

    const sendOTP = (acc: any) => {
        setTimer(60);
        setIsResendEnabled(false);
        setAcc(acc)
        otpAcc.instance.sendOTPAccountByNit(acc.Nit).then(
            (resp) => {
                toast.success('Codigo de Verificación Enviado Exitosamente.');
                setTimer(60);
                setIsResendEnabled(false);
                setModal({ ...modal, view: true });
            }
        ).catch(
            err => { toast.error("No se pudo enviar el Codigo de Verificación") }
        )
    }

    const [otpValues, setOtpValues] = useState(Array(6).fill(''));
    const inputRefs = useRef<HTMLInputElement[]>([]);

    const handleChangeOtpValue = (value: string, index: number) => {
        if (!/^\d*$/.test(value)) return; // Solo permitir dígitos

        const updatedValues = [...otpValues];
        updatedValues[index] = value;
        setOtpValues(updatedValues);
        if (value && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };


    const handleSubmit = () => {
        const otpCode = otpValues.join('');
        if (otpCode.length === 6) {
            validateOTP(otpCode, acc.IDAccount);
        } else {
            toast.error('Por favor completa el código OTP.');
        }
    };

    const validateOTP = (code: string, idAccount: number) => {
        otpAcc.instance.validateOTPAccount(idAccount, code).then(
            (resp) => {
                if (resp.Valid === true) {
                    setFirmas(prevFirmas =>
                        prevFirmas.map(firma =>
                            firma.IDAccount === idAccount
                                ? { ...firma, Validated: true }
                                : firma
                        )
                    );
                    setModal({ ...modal, view: false });
                    toast.success('Confirmación exitosa');
                    setAcc({});
                    setOtpValues(Array(6).fill(''));
                } else {
                    toast.error("Código OTP incorrecto");
                }
            }
        ).catch(() => {
            toast.error("Hubo un inconveniente, inténtelo nuevamente más tarde");
        });
    };

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
            return () => clearInterval(interval);
        } else {
            setIsResendEnabled(true);
        }
    }, [timer]);

    const handleResend = () => {
        if (isResendEnabled) {
            sendOTP(0);
            setTimer(60);
            setIsResendEnabled(false);
        }
    };

    const removeFirma = (idAccount: number) => {
        setFirmas(prevFirmas => prevFirmas.filter(firma => firma.IDAccount !== idAccount));
    };

    const [isEnviarDisabled, setIsEnviarDisabled] = useState(true);

    useEffect(() => {
        // Verifica siempre si hay más de 1 firma y si todas están validadas
        const hasEnoughFirmas = firmas.length >= 1;
        const allValidadas = firmas.every(f => f.Validated === true);

        console.log(hasEnoughFirmas, allValidadas)

        setIsEnviarDisabled(!(hasEnoughFirmas && allValidadas));
    }, [firmas, acc]);

    const crearComite =()=>{
        _credit.instance.crearActaComite(_single.getAccountID(),JSON.stringify(firmas),JSON.stringify({}),fechaCorte,fechaCorte,noActa,"").then(
            (resp:any)=>{
                console.log(resp);
                if(onCreateComite)
                        onCreateComite(true);

                    toast.success("Comite actualizado y firmado exitosamente");
                
            }
        )
    }
     const actionsDropDown = [
    {id:1,name:'Reporte Grafico',permiso:null,activo:true},
     
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">                    
                       <DropDown lista={actionsDropDown} eventClick={(e)=>{
                        if(e.id === 1)
                            modalGraph.open();
                       }}></DropDown>                   
                </div>
            </div>
        )
    }


    return (
        <div className="row">

            <div className="col-md-4">
                <InputDate label="Fecha Desembolso" value={fechaCorte} setDate={(e) => { setFechaCorte(e) }} name="fechaCorte" />
            </div>
            <div className="col-md-4">
                <label>No Comite</label>
                <input type="text" name="Acta" value={noActa ?? '' } onChange={(e)=>{setNoActa(e.target.value)}} className="form-control" />
            </div>
            <div className="col-md-12 mt-4">
                <h5>Firmas del documento</h5>
                <div className="row">
                    <div className="col-md-4">
                        <label >Cargo</label>
                        <input type="text" className="form-control" value={data.Cargo} onChange={(e) => { setData({ ...data, "Cargo": e.target.value }) }} />
                    </div>
                    <div className="col-md-4">
                        <AccountEditor label="Integrante" idAccount={acc.IDAccount} onChange={(e) => { setAcc(e) }} />
                    </div>
                    <div className="col-md-4 mt-4">
                        <BasicButton icon="" eventClick={addFirma} >Agregar</BasicButton>
                    </div>
                </div>
            </div>
            <div className="col-md-8 mt-4">
                {/* <PrintJson json={firmas}/> */}
                <fieldset>
                    <h6>Firmas del Documento</h6>
                    <ul className="list-group">
                        {firmas.map((item) => {
                            return (
                                <li className="list-group-item">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <strong>{item.Cargo}</strong> / {item.Nit} - {item.Name}
                                        </div>
                                        <div className="col-auto">
                                            {item.Validated ? (
                                                <p className="mb-0 text-success">Usuario Validado</p>
                                            ) : (
                                                <span className="link text-primary cursor" onClick={() => sendOTP(item)}>OTP</span>
                                            )}
                                        </div>
                                       {!item.Validated && 
                                        <div className="col-auto">
                                            <span className="link text-danger cursor" onClick={() => { removeFirma(item.IDAccount) }}>Eliminar</span>
                                        </div>
                                       }
                                    </div>
                                </li>

                            )
                        })}
                    </ul>
                </fieldset>
            </div>

            <div className="col-md-4 d-flex align-items-center">
                <BasicButton
                    eventClick={() => {crearComite() }}
                    icon="ri-send-plane-line"
                    disable={isEnviarDisabled}
                >
                    Enviar listado a comité
                </BasicButton>


            </div>

            <div className="col-md-12 mt-4">
                <BasicTable headButtons={buttons()} head={head} body={lista} rowSet={setBean} ></BasicTable>
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={handleSubmit} >
                    <div className="row">
                        <div className="text-center">
                            <div className="title">OTP - Codigo de Verificación</div>
                            <p className="message_otp">Te hemos enviado un código de verificación a tu correo electrónico</p>
                        </div>
                        <div className="col-md-12 inputs">
                            {otpValues.map((_, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    maxLength={1}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    value={otpValues[index]}
                                    onChange={(e) => handleChangeOtpValue(e.target.value, index)}

                                    onKeyDown={(e) => {
                                        if (e.key === 'Backspace') {
                                            if (otpValues[index] === '' && index > 0) {
                                                inputRefs.current[index - 1]?.focus();
                                            } else {
                                                handleChange('');
                                            }
                                        } else if (e.key === 'ArrowRight' && index < inputRefs.current.length - 1) {
                                            inputRefs.current[index + 1]?.focus();
                                        } else if (e.key === 'ArrowLeft' && index > 0) {
                                            inputRefs.current[index - 1]?.focus();
                                        } else if (!/^\d$/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    className="otp-input"
                                />
                            ))}
                        </div>
                        <div className="col-md-12 mt-4">
                            <p className="resendNote">
                                ¿No reicibiste el OTP? {isResendEnabled ? '' : ` - (${timer}s)`}
                                <button
                                    className="resendBtn"
                                    onClick={handleResend}
                                    disabled={!isResendEnabled}
                                >
                                    Reenviar Codigo
                                </button>
                            </p>
                        </div>
                    </div>
                </Modal>
                 <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={headGraph} useIndexAsXLabel={true}
                            xOptions={['NominaName', 'LoanLineName', 'DeudorName', 'IDGradoPersonaName', 'CiudadResidencia','IDGeneroName']}
                            yOptions={['AmountApprove', 'DeduccionCapital', 'Cuotes', 'TotalDesembolso']} />
                        {/* <PrintJson json={lista}/> */}
                    </Modal>
            </div>
        </div>
    )
}